import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { EnvironmentBannerComponent } from './shared/environment-banner/environment-banner.component'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, EnvironmentBannerComponent],
  template: '<app-environment-banner /><router-outlet />',
})
export class App {}
